(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-block-recommended-products"] && !Shopify.designMode) return;
  try {
    class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.container = null;
      this.productId = null;
      this.limit = 8;
      this.baseUrl = '';
      this.sectionId = '';
      this.abortController = null;
      this.onCartChangeCallback = this.onCartChange.bind(this);
    }

    connectedCallback() {
      this.container = this.querySelector('[data-recommendations-container]');
      this.productId = this.getAttribute('data-product-id');
      this.limit = parseInt(this.getAttribute('data-limit')) || 8;
      this.baseUrl = this.getAttribute('data-url');
      this.sectionId = this.getAttribute('data-section-id');

      if (this.productId && this.baseUrl) {
        this.fetchRecommendations();
      }

      document.addEventListener('theme:cart:change', this.onCartChangeCallback);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:change', this.onCartChangeCallback);

      if (this.abortController) {
        this.abortController.abort();
      }
    }

    onCartChange() {
      this.refreshFromCart();
    }

    async refreshFromCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.items && cart.items.length > 0) {
          const mostRecentItem = cart.items[0];
          const newProductId = mostRecentItem.product_id;

          // Show the element if it was hidden
          this.classList.remove('hidden');

          // Auto-open if setting is enabled and this is first item
          if (this.getAttribute('data-auto-open') === 'true' && !this.hasAttribute('open')) {
            this.setAttribute('open', 'true');
            const collapsibleBody = this.querySelector('[data-collapsible-body]');
            if (collapsibleBody) {
              collapsibleBody.style.height = 'auto';
            }
          }

          if (newProductId && newProductId != this.productId) {
            this.productId = newProductId;
            this.setAttribute('data-product-id', newProductId);
            this.fetchRecommendations();
          }
        } else {
          this.classList.add('hidden');
        }
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }

    async fetchRecommendations() {
      if (!this.productId || !this.baseUrl || !this.sectionId) return;

      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      const url = `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=related`;

      this.showLoading();

      try {
        const response = await fetch(url, {
          signal: this.abortController.signal
        });

        if (!response.ok) throw new Error('Failed to fetch recommendations');

        const html = await response.text();
        this.handleResponse(html);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching recommendations:', error);
          this.showEmpty();
        }
      }
    }

    handleResponse(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const template = doc.querySelector('[data-api-cart-recommendations]');

      if (template && template.innerHTML.trim()) {
        this.container.innerHTML = template.innerHTML;

        const gridSlider = this.container.querySelector('grid-slider');
        if (gridSlider) {
          gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
        }

        this.initQuickAdd();
      } else {
        this.showEmpty();
      }
    }

    showLoading() {
      if (!this.container) return;

      this.container.innerHTML = `
        <div class="cart__recommendations-loading">
          <span class="cart__recommendations-loader"></span>
        </div>
      `;
    }

    showEmpty() {
      if (!this.container) return;
      this.container.innerHTML = '<div class="cart__recommendations-empty-state"></div>';
    }

    initQuickAdd() {
      const quickAddElements = this.querySelectorAll('quick-add-product');
      quickAddElements.forEach(element => {
        if (typeof element.connectedCallback === 'function') {
          element.connectedCallback();
        }
      });
    }
  }

  if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
  }

  // Prevent cart drawer from closing when quick add modal opens from within it
  // and reopen cart drawer when quick add modal closes
  (function() {
    let openedFromCartDrawer = false;

    document.addEventListener('click', (e) => {
      const quickAddBtn = e.target.closest('[data-quick-add-modal-handle]');
      if (quickAddBtn) {
        const cartDrawer = quickAddBtn.closest('cart-drawer');
        if (cartDrawer) {
          openedFromCartDrawer = true;
        }
      }
    });

    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-quick-add-modal-close]');
      if (closeBtn && openedFromCartDrawer) {
        openedFromCartDrawer = false;
        // Reopen cart drawer after modal closes
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
          }
        }, 100);
      }
    });

    // Also handle when product is added from quick add modal
    document.addEventListener('theme:product:added', () => {
      if (openedFromCartDrawer) {
        openedFromCartDrawer = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
